import { render, staticRenderFns } from "./check-test.vue?vue&type=template&id=4bfe2c73&scoped=true"
import script from "./check-test.vue?vue&type=script&lang=js"
export * from "./check-test.vue?vue&type=script&lang=js"
import style0 from "./check-test.vue?vue&type=style&index=0&id=4bfe2c73&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe2c73",
  null
  
)

export default component.exports